import { useInitOnce } from '@/generic/init';
import { PROVIDE_DIAGNOSTIC, provideDiagnostic } from '@/diagnostic/DiagnosticProvider.ts';
import { DiagnoseComponent } from '@/diagnostic/primary/DiagnoseComponent.tsx';

export const DiagnosticApp = () => {
  useInitOnce(PROVIDE_DIAGNOSTIC, provideDiagnostic);
  return <DiagnoseComponent />;
};
